  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faqrs-question').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('.faqrs-item');
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.faqrs-item').forEach((i) => {
          i.classList.remove('faqrs-active');
          i.querySelector('.faqrs-question').setAttribute('aria-expanded', 'false');
        });

        if (!expanded) {
          item.classList.add('faqrs-active');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  });